import React, { useState } from "react";

const products = [
  {
    title: "APC-CRM Console",
    image:
      "https://images.unsplash.com/photo-1556155092-8707de31f9c4?auto=format&fit=crop&w=1200&q=80",
    short:
      "Business CRM website developed to manage customers and leads.",
    content:
      "APC-CRM is a web-based customer relationship management website developed by Technoweit. It allows businesses to manage customer details, leads, follow-ups, sales activities, and reports through a centralized dashboard. The website focuses on improving customer engagement and business productivity.",
  },
  {
    title: "School Management System",
    image:
      "https://images.unsplash.com/photo-1588072432836-e10032774350?auto=format&fit=crop&w=1200&q=80",
    short:
      "School management website for digital academic administration.",
    content:
      "The School Management System is a complete website solution created to manage school operations digitally. It includes student registration, attendance tracking, exam management, fee records, teacher data, and parent communication, helping schools reduce paperwork and improve efficiency.",
  },
  {
    title: "Technoweit Admin Panel",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
    short:
      "Internal admin website for Technoweit operations.",
    content:
      "Technoweit Admin is an internal website developed to manage organizational activities such as courses, students, trainers, placements, blogs, and website content. It provides role-based access and helps streamline internal management processes.",
  },
  {
    title: "Housing Management System",
    image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80",
    short:
      "Housing society management website.",
    content:
      "The Housing Management website is designed to manage residential societies efficiently. It handles resident records, maintenance payments, notices, complaints, parking information, and financial reports, offering a digital solution for smooth society administration.",
  },
];

const Product = () => {
  const [activeProduct, setActiveProduct] = useState(null);

  return (
    <>
      <div className="bg-black py-10 md:py-20 text-center">
        <h2 className="text-5xl font-bold text-white">
          Our Products
        </h2>
        <p className="mt-3 text-gray-300">
          Websites and web applications developed by Technoweit
        </p>
      </div>

      <div className="bg-gray-100 py-10 md:py-20 px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition overflow-hidden"
            >
              <img
                src={product.image}
                alt={product.title}
                className="h-52 w-full object-cover"
              />

              <div className="p-6">
                <h3 className="text-2xl font-semibold text-gray-800">
                  {product.title}
                </h3>

                <p className="mt-2 text-gray-600 text-sm">
                  {product.short}
                </p>

                <button
                  onClick={() => setActiveProduct(product)}
                  className="mt-4 rounded bg-black px-4 py-2 text-sm text-white hover:bg-gray-800 transition"
                >
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {activeProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
          <div className="relative w-[90%] max-w-2xl rounded-xl bg-white p-6 shadow-xl">
            <button
              onClick={() => setActiveProduct(null)}
              className="absolute top-3 right-4 text-2xl font-bold text-gray-500 hover:text-black"
            >
              ×
            </button>

            <img
              src={activeProduct.image}
              alt={activeProduct.title}
              className="mb-4 h-60 w-full rounded-lg object-cover"
            />

            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              {activeProduct.title}
            </h2>

            <p className="text-gray-700 leading-relaxed">
              {activeProduct.content}
            </p>

            <div className="mt-6 text-right">
              <button
                onClick={() => setActiveProduct(null)}
                className="rounded bg-black px-6 py-2 text-white"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Product;
